// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/3718c3281d06b0966889.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"ecc7fb238ca3c34c3524","265":"5ec45951b9a58cac8a8e","266":"671371d1ef277ee8eaf4"}[chunkId] + ".chunk.js";
};